import { Redirect, Route, Switch } from "react-router-dom";
import Login from "../../pages/Login";
import Signup from "../../pages/Signup";
export const NewUserroutes = () => {
  return (
    <>
      <Route exact path="/" component={Login}></Route>
      <Route exact path="/login" component={Login}></Route>
      <Route exact path="/signup" component={Signup}></Route>
    </>
  );
};
export const navs = () => {};
